import { INofiticationRequest } from "../../../model/request/nofitication/INofiticationRequest";
import { INotificationActionTypes } from "../../action-types/nofitication/INofiticationActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { INotificationReducer } from "../../reducer-model/notification/INotificationReducer";

const PAGE_SIZE = 20;

const iniState: INotificationReducer = {
  isShow: false,
  notifications: [],
  readStatus: "all",
  status: eReducerStatusBase.is_not_initialization,
  request: {} as INofiticationRequest,
  totalCount: 0,
  unreadCount: 0,
  pageIndex: 0,
  hasMore: false,
};

export const nofiticationReducer = (
  state: INotificationReducer = iniState,
  action: INotificationActionTypes,
): INotificationReducer => {
  switch (action.type) {
    case "NOFITICATION_CHANGE_READ_STATUS":
      // Đổi bộ lọc → reset về trang đầu để saga tải lại từ đầu.
      return { ...state, readStatus: action.payload, pageIndex: 0 };

    case "NOFITICATION_CHANGE_SHOW":
      return { ...state, isShow: action.payload };

    case "NOFITICATION_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };

    case "NOFITICATION_LOAD_SUCCESS": {
      const { items, total_count, unread_count, append } = action.payload;
      const merged = append ? [...state.notifications, ...items] : items;
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        notifications: merged,
        totalCount: total_count,
        unreadCount: unread_count,
        pageIndex: append ? state.pageIndex + 1 : 0,
        hasMore: merged.length < total_count && items.length >= PAGE_SIZE,
      };
    }

    case "NOFITICATION_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "NOFITICATION_LOAD_UNREAD_COUNT_SUCCESS":
      return { ...state, unreadCount: action.payload };

    case "NOFITICATION_MARK_READ_SUCCESS": {
      const id = action.payload;
      // id = 0 ⇒ đọc tất cả; ngược lại đánh dấu 1 thông báo.
      const notifications = state.notifications.map((n) =>
        id === 0 || n.id === id ? { ...n, is_read: true } : n,
      );
      const unreadCount =
        id === 0 ? 0 : Math.max(0, state.unreadCount - 1);
      // Nếu đang lọc "chưa đọc" thì loại các dòng vừa đọc khỏi danh sách.
      const visible =
        state.readStatus === "unread"
          ? notifications.filter((n) => !n.is_read)
          : notifications;
      return { ...state, notifications: visible, unreadCount };
    }

    case "NOFITICATION_SET_TRANG_THAI": {
      const { id, trang_thai } = action.payload;
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, trang_thai } : n,
        ),
      };
    }

    default:
      return state;
  }
};
